import { isNull, omitBy } from 'lodash';

export const createDDBItem = (data: any) => {
  return omitBy(
    {
      name: data.name,
      subtitle: data.subtitle ?? null,
      is_active: data.is_active,
    },
    isNull,
  );
};
